import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm, LabelCabecera } from '../componentes_generales/componentes_formulario/labels/';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { validarPermisoAcceso } from '../../funciones_globales/utils';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { TextArea } from '../componentes_generales/componentes_formulario/textArea/textarea';
import { formatearFecha } from '../../funciones_globales/format';

const ContenedorModal = styled.div`  
    margin-top: 20px;
    height: 100%;
    width: 250px;
`;

const ContenedorModalHistorial = styled.div`  
    margin-top: 20px;
    height: 100%;
    width: 750px;
`;

class FormVen08 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            //Estados formulario
            operacion: 'G', //G & M
            permiso: 'G',
            ult_transaccion: null,
            num_diario: null,
            movimientoId: '',
            cod_proveedor: null,

            //Radio
            tipoDevolucion: 'L',

            //FECHAS
            fechaProceso: null,

            //Modals
            isOpenModalFac: false,
            isOpenModalHistorial: false,
            cabecera: '',

            //LABEL
            labelArt: "",
            modalHistorial: "",

            //REFUND SELECTION
            devolucion_sel: null,

            //TextArea
            motRechazo: "",
            motAprobacion: "",
            obsGerencia: "",
            obsContraloria: "",
            obsComercial: "", 

            //GRIDS
            gridHistorial: [],
            colDefHistorial:[
                                {   header: "Sec.",
                                    field: "Secuencia",
                                    width: 40,
                                    type: "string"
                                },
                                {   header: "Tipo.",
                                    field: "Tipo",
                                    width: 80,
                                    type: "string"
                                },
                                {   header: "Fecha",
                                    field: "Fecha",
                                    width: 110,
                                    type: "string"
                                },                          
                                {   header: "Usuario",
                                    field: "Usuario",
                                    width: 60,
                                    type: "string"
                                },
                                {   header: "Area",
                                    field: "Area",
                                    width: 110,
                                    type: "string"
                                },
                                {   header: "Observacion",
                                    field: "Observacion",
                                    width: 330,
                                    type: "string"
                                }
                            ],
            gridDetFactura: [],
            colDefDetFactura:[
                                {    header: "Sec.",
                                    field: "Secuencia",
                                    width: 50,
                                    type: "string"
                                },
                                {   header: "Fecha",
                                    field: "Fecha",
                                    width: 50,
                                    type: "fecha"
                                },                          
                                {   header: "Factura",
                                    field: "Factura",
                                    width: 70,
                                    type: "string"
                                },
                                {   header: "Cantidad",
                                    field: "Cantidad",
                                    width: 50,
                                    type: "num_entero"
                                }
                            ],
            dataDetDevoluciones: [],
            coldefDetDevoluciones: [
                                        {   header: "Sec.",
                                            field: "Secuencia",
                                            width: 50,
                                            type: "string"
                                        },
                                        {   header: "Artículo",
                                            field: "Articulo",
                                            width: 70,
                                            type: "string"
                                        },                          
                                        {   header: "Descripción",
                                            field: "DescripcionArt",
                                            width: 250,
                                            type: "string"
                                        },
                                        {   header: "Cantidad",
                                            field: "Cantidad",
                                            width: 65,
                                            type: "num_entero"
                                        },
                                        {   header: "Recibido",
                                            field: "Recibido",
                                            width: 65,
                                            type: "num_entero"                                 
                                        },
                                        {   header: "Motivo",
                                            field: "Motivo",
                                            width: 60,
                                            type: "num_entero"                                 
                                        },
                                        {   header: "Descripcion",
                                            field: "DescripcionMotivo",
                                            width: 200,
                                            type: "string"                                 
                                        },
                                        {   header: "MotivoVerificado",
                                            field: "MotivoReal",
                                            width: 120,
                                            type: "string"                                 
                                        },
                                        {   header: "Cant. Real",
                                            field: "CantidadReal",
                                            width: 70,
                                            type: "num_entero"                                 
                                        },
                                        {   header: "Aprob",
                                            width: 60,                    
                                            checkboxSelection: true,
                                            suppressSorting: true,
                                            suppressMenu: true,
                                            suppressFilter: true,                                        
                                        }
                                    ],
            dataDevolucionesPorAprobar: [],
            coldefDevolucionesPorAprobar:[
                                            {  header: "Devolución",
                                                field: "Devolucion",
                                                width: 80,
                                                type: "string"
                                            },
                                            {   header: "V.Aprox.",
                                                field: "Total",
                                                width: 60,
                                                type: "num_decimal"
                                            },                          
                                            {   header: "Fecha",
                                                field: "Fecha",
                                                width: 70,
                                                type: "string"
                                            },
                                            {   header: "Vendedor",
                                                field: "VendedorName",
                                                width: 100,
                                                type: "string"
                                            },
                                            {   header: "Cliente",
                                                field: "ClienteName",
                                                width: 310,
                                                type: "string"                                 
                                            },
                                            {   header: "Aprob",
                                                width: 50,                    
                                                checkboxSelection: true,
                                                suppressSorting: true,
                                                suppressMenu: true,
                                                suppressFilter: true                                             
                                            },
                                            {   header: "Motivo Rechazo",
                                                field: "MotRechazo",
                                                width: 320,
                                                type: "string" ,
                                                editable: true,
                                                hide: false                 
                                            }
                                        ],
        };

        //Properties
        this.DevolucionesPorAprobarOptions = {
            context: {
                componentParent: this
            },
            rowSelection: "multiple",
            suppressRowClickSelection: true,
            singleClickEdit: true,
            enableColResize: true,
            getRowStyle:(params)=>{
                //FUNCION QUE MARCA LAS DEVOLUCIONES CON RECHAZO CODIGO 02
                if (params.data.Rechazos.length>0){
                    for(var i=0; i<params.data.Rechazos.length; i++){
                        if(params.data.Rechazos[i].CodigoProceso==='02'){
                            return {'background-color':'#ed6d6d'}
                        }
                    }
                }
                return null;
            },
            enableCellChangeFlash: true,
            onRowSelected: ((event)=>{
                var touched = false;
                if(event.node.selected===true){
                    if(this.state.tipoDevolucion==='F'){
                        var seleccionados = this.apiDevolucionesPorAprobar.getSelectedRows();
                        if(seleccionados.length > 1){
                            event.node.setSelected(false);
                            touched = true;
                        }
                    }

                    if(touched===false){
                        //Al ser seleccionada carga el detalle de la devolucion por medio del ID (Recuerda la seleccion)
                        //SELECCION CASE IF EXISTE EN MASTER ARRAY CARGA DESDE MASTER ARRAY SINO LLAMA A API
                        this.cargarDetalleDevolucionId(event.node.data.Devolucion, this.state.tipoDevolucion==='F'?true:false);
                        this.cargarComentarios(event.node.data);
                        this.serchOnMasterArray(event.node.data.Devolucion)
                        this.setState({devolucion_sel: event.node.data.Devolucion})
                        if(event.node.data.hasOwnProperty('MotRechazo')===true){
                            delete event.node.data.MotRechazo;
                            this.apiDevolucionesPorAprobar.refreshCells();
                        }
                    }
                }else if(event.node.selected===false /*&& this.state.tipoDevolucion==='F'*/){
                    this.apiDetDevoluciones.deselectAll();
                    
                }
            }),
            onRowDataChanged:((event)=>{}),
            onCellValueChanged:((event)=>{
                if(event.colDef.field==="MotRechazo" && event.data.MotRechazo!==""){
                    event.node.setSelected(false);
                }else if(event.colDef.field==="MotRechazo" && event.data.MotRechazo===""){
                    delete event.data.MotRechazo;
                    this.apiDevolucionesPorAprobar.refreshCells();
                }
            }),
            onCellEditingStarted:((event)=> {
            }),
            onRowClicked:((event)=>{  
                
                //Al ser seleccionada carga el detalle de la devolucion por medio del ID (Recuerda la seleccion)
                this.cargarDetalleDevolucionId(event.data.Devolucion, event.node.selected===true?true:false);
                this.cargarComentarios(event.data);
                this.setState({devolucion_sel: event.data.Devolucion})
            })
        };

        this.DetDevolucionesOptions = {
            context: {
                componentParent: this
            },
            rowSelection: "multiple",
            suppressRowClickSelection:true,
            singleClickEdit: true,
            enableColResize: true,
            enableCellChangeFlash: true,
            onRowSelected: ((event)=>{
                //SELECCION EN BASE A VALORES PERMITIDOS
                this.asignacionValorAprobacionDet('A');
            }),
            getRowStyle:(params)=>{
                if (params.data.Aprobacion ==='P'){
                    return {'background-color':'#FCB24B'}
                }
                return null;
            },
            onRowDataChanged:((event)=>{}),
            onCellValueChanged:((event)=>{}),
            onCellEditingStarted:((event)=> {}),
            onRowDoubleClicked:((event)=>{
                this.cargarObjetos('/devolucionesporaprobar?tipo=factura&devolucion='+event.node.data.Devolucion+'&art='+event.node.data.Articulo).then((DEVFAC)=>{
                    this.setState({gridDetFactura: [], labelArt: "" });
                    this.asignarFacturaGrid(DEVFAC);
                    this.setState({isOpenModalFac: true, labelArt: event.node.data.Articulo});
                })
            })
        };

        this.gridOptionsDetFactura = {
            context: {
                componentParent: this
            },
            rowSelection: "single",
            suppressRowClickSelection:true,
            singleClickEdit: false,
            enableColResize: false,
        };

        this.gridOptionsHistorial = {
            context: {
                componentParent: this
            },
            getRowStyle:(params)=>{
                //FUNCION QUE LA CABECERA DEL HISTORIAL
                if (params.data.Tipo==='N/A'){
                    return {'background-color':'#ffee8a'}
                }
                return null;
            },
            rowSelection: "single",
            suppressRowClickSelection:true,
            singleClickEdit: false,
            enableColResize: true,
            enableSorting: true
        };

        //Operaciones
        this.cargarDevoluciones = this.cargarDevoluciones.bind(this);
        this.toggleModalHistorial = this.toggleModalHistorial.bind(this);
        this.guardarAprobacionDevolucionElectronica = this.guardarAprobacionDevolucionElectronica.bind(this);
        //GRIDS
        this.onGridDevolucionesPorAprobarReady = this.onGridDevolucionesPorAprobarReady.bind(this);
        this.onGridDetDevolucionesReady = this.onGridDetDevolucionesReady.bind(this);
        this.onGridDetFacturaReady = this.onGridDetFacturaReady.bind(this);
        this.onGridHistorialReady = this.onGridHistorialReady.bind(this);
        //OverControls
        this.actualizarCampos = this.actualizarCampos.bind(this);
        this.limpiarPantalla = this.limpiarPantalla.bind(this);
    }

    //OVERCONTROLS
    actualizarCampos(event){
        const target = event.target;       
        const name = target.name;    
        const value = target.type === 'checkbox'? target.checked : target.value;
        this.setState({
          [name]: value
        });
        if(name==='tipoDevolucion'){
            this.cargarDevoluciones(value);
            this.setState({obsContraloria: "",obsComercial: "", dataDetDevoluciones: [], devolucion_sel: null});
        }

        //Funcion para ocultar columna
        if(name==='tipoDevolucion' && value==='L'){
            this.columnApiDevolucionesPorAprobar.setColumnVisible('MotRechazo',true)
        }else if(name==='tipoDevolucion' && value==='F'){
            this.columnApiDevolucionesPorAprobar.setColumnVisible('MotRechazo',false)
        }
    }

    //GET
    cargarObjetos(ruta){
        return new Promise((resolve, reject) => {
            global_axios.get(ruta)
            .then((response)=>{
                resolve(response.data)
            })
            .catch((err)=>{
                reject(err);
            });
        });
    }

    //Carga Devoluciones por Status L o F
    cargarDevoluciones(tipo){
        if(tipo==='F'){
            tipo = 'F&status=RG'
        }
        this.cargarObjetos('/devolucioneselectronicas?status='+tipo).then((resultAprob)=>{
            var ArrayDevoluciones = [];
            resultAprob.forEach((DEV)=>{
                var item = {};
                item.Devolucion = DEV.Devolucion;
                item.Total = 0//DEV.Total;
                item.Fecha = DEV.Fecha;
                item.Vendedor =  DEV.Vendedor;
                item.VendedorName = DEV.vend!==null?DEV.vend.Nombre:'N/A';
                item.Cliente = DEV.Cliente;
                item.ClienteName = DEV.cli!==null?DEV.cli.Nombre: 'N/A';
                item.Total = Math.round(DEV.TotalAprx*100)/100;
                item.Rechazos = DEV.rechazos;
                //Data de Comentarios por devolucion
                item.obsComercial = DEV.ObsG1!==null?(DEV.ObsG1!==""?DEV.ObsG1:'N/A'):'N/A'
                item.obsContraloria = DEV.ObsG2!==null?(DEV.ObsG2!==""?DEV.ObsG2:'N/A'):'N/A'
                item.obsVendedor = DEV.Observacion!==null?(DEV.Observacion!==""?DEV.Observacion:'N/A'):'N/A'
                //Data de cabecera de historial por devolucion
                item.URevision1 = DEV.URevision1;
                item.URevision2 = DEV.URevision2;
                item.FRevision1 = DEV.FRevision1;
                item.FRevision2 = DEV.FRevision2;
                ArrayDevoluciones.push(item);
            });
            
            this.setState({dataDevolucionesPorAprobar: ArrayDevoluciones},()=>{
                if(tipo==='L'){
                    this.apiDevolucionesPorAprobar.selectAll();
                }
                this.setState({dataDetDevoluciones: []})
            ;})
        })
    }

    cargarDetalleDevolucionId(idDevolucion, selected){
        this.cargarObjetos('/devolucionesporaprobar/'+idDevolucion).then((resultID)=>{
            var arrayDetalle = [];
            resultID.devolucion.detDevolucion.forEach((DET)=>{
                var item = {};
                item.Devolucion = DET.Devolucion;
                item.Secuencia = DET.Secuencia;
                item.Articulo = DET.Articulo;
                item.DescripcionArt = DET.art!==null?DET.art.Nombre:'N/A';
                item.Cantidad = DET.Cantidad;
                item.Recibido = DET.Recibido;
                item.Motivo = DET.Motivo;
                item.DescripcionMotivo = DET.motivo!==null?DET.motivo.Descripcion:'N/A';
                item.MotivoRealCode = DET.MotivoReal;
                item.MotivoReal = DET.motivoreal!==null?DET.motivoreal.Descripcion:'N/A';
                item.CantidadReal = DET.CantidadReal; 
                item.Aprobacion = DET.Aprobacion!==null?DET.Aprobacion:'P';

                if(resultID.devolucion.facturasAsignadasPorArt.length>0){
                    var arraySubItems = [];
                    resultID.devolucion.facturasAsignadasPorArt.forEach((ASG)=>{
                        if(ASG.Devolucion === item.Devolucion){
                            var subItem = {};
                            subItem.Articulo = ASG.Articulo 
                            subItem.Factura = ASG.IdFactura
                            subItem.Anios = ASG.Anios
                            subItem.Cantidad = ASG.Cantidad
                            item.Anios = ASG.Anios;
                            arraySubItems.push(subItem);
                        }
                    })
                    item.facturasAsignadasPorArt = arraySubItems;
                }

                arrayDetalle.push(item);
            })

            this.setState({dataDetDevoluciones: arrayDetalle},()=>{
                if(selected===true){
                    this.apiDetDevoluciones.selectAll();
                }                
                //CargarSeleccion Automatica
                this.asignacionValorAprobacionDet('A')
            })
        })
    }

    cargarComentarios(fila){
        if(fila.obsContraloria!==""||fila.obsContraloria!==null){
            this.setState({obsContraloria: fila.obsContraloria})
        }
        if(fila.obsComercial!==""||fila.obsComercial!==null){
            this.setState({obsComercial: fila.obsComercial});
        }
        var comp = 0, msn="N/A";  
        if(fila.Rechazos.length > 0){
            fila.Rechazos.forEach((CG)=>{
                if(comp <= CG.IdRechazo){
                    comp = CG.IdRechazo;
                    msn = CG.MotivoRechazo;
                }
            })
        }
        this.setState({obsGerencia: msn});
    }

    //Methods
    onGridDevolucionesPorAprobarReady(params){
        this.apiDevolucionesPorAprobar = params.api;
        this.columnApiDevolucionesPorAprobar = params.columnApi;
    }

    onGridDetDevolucionesReady(params){
        this.apiDetDevoluciones = params.api;
        this.columnApiDetDevoluciones = params.columnApi;
    }

    onGridDetFacturaReady(params){
        this.apiDetFactura = params.api;
        this.columnApiDetFactura = params.columnApi;
    }

    onGridHistorialReady(params){
        this.apiHistorial = params.api;
        this.columnApiHistorial = params.columnApi;
    }

    asignarFacturaGrid(array){
        if(array.length > 0){
            var ArrayFact = [];
            array.forEach((FAC,i)=>{
                var item = {};
                item.Devolucion = FAC.Devolucion;
                item.Secuencia = i+1;
                item.Cantidad = FAC.Cantidad;
                item.Fecha = FAC.fac!==null?FAC.fac.Fecha:'N/A';
                item.Factura = FAC.fac!==null?FAC.fac.Factura:'N/A';
                
                ArrayFact.push(item);  
            })
            this.setState({gridDetFactura: ArrayFact})
        }
    }

    serchOnMasterArray(dev){
        var find = false
        this.apiDetDevoluciones.forEachNode((DET)=>{
            if(DET.data.Devolucion === dev){
                find = true
            }
        })
        return find;
    }

    //CASO A => AUTOMATICO CARGA CON VALORES POR DEFECTO
    //CASO M => MODIFICACION SETEA UN VALOR PERMITIDO
    asignacionValorAprobacionDet(params){
        this.apiDetDevoluciones.forEachNode(node => {
            if( node.data.Aprobacion !== null ){
                switch (node.data.Aprobacion) {
                    case 'P':
                        if(params==='M'){
                            node.setSelected(false);
                        }
                        break;
                    case 'A':
                        if(params==='M'){
                            node.setSelected(true);
                        }
                        break;
                    case 'N':
                        node.setSelected(false);
                        break;
                    case 0:
                        node.setSelected(false);
                        break;
                
                    default:
                        break;
                }
                
            }
        });
    }

    //Abre el Modal para el Histotial
    toggleModalHistorial(parametro){
        this.setState({gridHistorial: [], cabecera: ''}, ()=>{
            this.setState({modalHistorial: 'Rechazo-Aprobación'})

            this.cargarObjetos('/devolucionesporaprobar?tipo=historial&devolucion='+this.state.devolucion_sel).then((historial)=>{
                this.setState({cabecera: this.crearCabecerahistorial(this.state.devolucion_sel)})
                var arrayHistory = [];

                historial.forEach((HT, i)=>{
                    let item = {};
                    item.Secuencia = arrayHistory.length+1;
                    item.Fecha = HT.FechaSistema;
                    item.Usuario = HT.Usuario!==null && HT.Usuario!==""?HT.Usuario.toUpperCase():'N/A';
                    item.Area = HT.Area!==null?HT.Area:'N/A';
                    item.Observacion = HT.Motivo!==""?HT.Motivo.toString().toUpperCase():'N/A';
                    item.Tipo = HT.Tipo==='A'?'APROBACIÓN':'RECHAZO';
                    arrayHistory.push(item);
                })
                this.setState({gridHistorial: arrayHistory})
            })
            
        })
        this.setState({isOpenModalHistorial: true});
    }

    //Crea la cabecera que se muestra en el modal de historial
    crearCabecerahistorial(idDevolucion){
        let filaDev = {};
        //let cabeceraHistorial = [];
        this.state.dataDevolucionesPorAprobar.forEach((DEV)=>{
            if(idDevolucion===DEV.Devolucion){
                filaDev = DEV;
            }else{
                return;
            }
        })

        let cabecera = `Fecha: ${this.formatearFechaHora(filaDev.FRevision2)} - REVISIÓN CANTIDAD POR: ${filaDev.URevision1!==null?filaDev.URevision1:'N/A'}\n
                        Fecha: ${this.formatearFechaHora(filaDev.FRevision1)} - REVISIÓN FÍSICA POR:   ${filaDev.URevision2!==null?filaDev.URevision2:'N/A'}`

        return cabecera;
    }

    //Formatea Fecha - Hora en 1 solo String
    formatearFechaHora(fechaSinFormato){
        var result = "N/A";
        if(fechaSinFormato !== null && fechaSinFormato !==""){
            let fecha = fechaSinFormato.toString().substring(0,10);
            let hora = fechaSinFormato.toString().substring(11,19);
            result = formatearFecha(fecha).concat(" "+hora);
        }
        return result;
    }

    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    //CICLO REACT
    componentDidMount(){
        Promise.all([
            this.props.generar_LogAuditoriaIngresoForm('0408')
         ])
        .then(()=>{
            this.setState({permiso: this.props.permiso, 
            fechaProceso: moment(this.props.fechaProceso, "DD/MM/YYYY")})
            this.cargarDevoluciones(this.state.tipoDevolucion);
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0408');
    }

    //Operacion Buttons
    limpiarPantalla(){
        this.setState({labelArt: '', modalHistorial: "",
        devolucion_sel: null, motRechazo:"", motAprobacion:"",
        gridHistorial: [], gridDetFactura: [], dataDetDevoluciones: [], cabecera:'',
        obsGerencia: "", obsContraloria: "", obsComercial: "", 
        });
    }

    guardarAprobacionDevolucionElectronica(){
        var errors = "";
        var proceder = true;
        var data = {};
        var msjRechazo = "- Se rechazarán los articulos: ";
        var msjRechazoListas = "- Se rechazarán las siguientes devoluciones y todos sus items asociados: "
        var confirmacion;

        //Validacion de permisos
        let operacion = validarPermisoAcceso(this.state.operacion, this.state.permiso)
        if(operacion.esValido===false){
            proceder = false;
            errors = errors+operacion.msg
        }

        //Preparacion Catalogos
        data.Usuario = this.props.usuario;
        data.Departamento = this.props.departamento;
        data.Tipo = this.state.tipoDevolucion;

        //Preparacion Data
        switch (this.state.tipoDevolucion) {
            case 'L':
                //LISTA
                var devRechazadas = "";
                var ArrayCabeceraDevolucion = [];
                var flagRechazo = false;
                this.apiDevolucionesPorAprobar.forEachNode((CAB)=>{
                    var item = {};
                    item = {...CAB.data, AprobacionFinal: (CAB.selected===true?true:false)}
                    ArrayCabeceraDevolucion.push(item);

                    if(item.AprobacionFinal===false){
                        msjRechazoListas = msjRechazoListas+""+item.Devolucion+", ";
                        flagRechazo = true;
                        //Valida q las devoluciones rechazadas tenga un comentario
                        if(CAB.data.hasOwnProperty('MotRechazo')===false){
                            proceder = false;
                            devRechazadas = devRechazadas+" "+CAB.data.Devolucion+", "
                        }
                    }
                })

                if(devRechazadas!==""){
                    errors = errors+"- Digite comentario de rechazo de las siguientes devoluciones: "+devRechazadas
                }

                //Alerta sobre los devoluciones rechazados
                if(flagRechazo === true){
                    confirmacion = window.confirm(msjRechazoListas+"\n¿Continuar?");
                    
                    if(confirmacion===false){
                        proceder = false;
                        errors = errors+"- Operación cancelada por el usuario\n"
                    }
                }
                data.CabDevolucion = ArrayCabeceraDevolucion;
                
                break;
            case 'F':
                //MODIFICADAS
                var comparation = this.state.dataDetDevoluciones;

                //Valida que la devolucion seleccionada sea la visualizada
                if(comparation.length > 0){

                    //Preparacion Catalogos
                    data.Devolucion = this.state.devolucion_sel;
                    data.ComentarioRechazo = this.state.motRechazo.toString().toUpperCase();
                    data.ComentarioAprobacion = this.state.motAprobacion.toString().toUpperCase();
                    data.Rechazo = false;

                    //ARRAY DEL DETALLE DEVOLUCION
                    var arrayEnvioMod = [];
                    
                    //ARRAY AUDITORIA DE CAMBIOS EN DEVOLUCIONES
                    var arrayAuditoria = [];

                    this.apiDetDevoluciones.forEachNode((DET)=>{
                        var item = {};
                        item = {...DET.data, AprobacionFinal: (DET.selected===true?'A':'N') }

                        if(item.hasOwnProperty('DescripcionArt') || item.hasOwnProperty('DescripcionMotivo') || item.hasOwnProperty('facturasAsignadasPorArt')){
                            delete item.DescripcionArt;
                            delete item.DescripcionMotivo;
                            delete item.facturasAsignadasPorArt;
                        }

                        arrayEnvioMod.push(item);

                        //Adicion de registro de cambios
                        console.log('COMPARACION ITEMS: ',  item.AprobacionFinal !== DET.data.Aprobacion, 'APROBACIONFINAL: ', item.AprobacionFinal, 'DET APROBACION: ' ,DET.data.Aprobacion)
                        if(item.AprobacionFinal !== DET.data.Aprobacion){
                            arrayAuditoria.push(item);
                        }

                        //Acumula articulos rechazados para el mensaje
                        if(item.AprobacionFinal==='N'){
                            msjRechazo = msjRechazo+""+item.Articulo+", "
                            data.Rechazo = true;
                        }
                    })

                    if(data.Rechazo === true && data.ComentarioRechazo===""){
                        proceder = false;
                        errors = errors+"- Ingrese un comentario de rechazo para continuar\n"
                    }
                    
                    if(data.Rechazo === false && data.ComentarioAprobacion===""){
                        proceder = false;
                        errors = errors+"- Ingrese un comentario de aprobación para continuar\n"
                    }

                    data.DetDevolucion = arrayEnvioMod;
                    data.AuditoriaCambios = arrayAuditoria;

                    //Alerta sobre los artículos rechazados
                    if(data.Rechazo === true){
                        confirmacion = window.confirm(msjRechazo+"\n¿Continuar?");
                        
                        if(confirmacion===false){
                            proceder = false;
                            errors = errors+"- Operación cancelada por el usuario\n"
                        }
                    }
                }
                break;
            default:
                break;
        }
        //Proceso de grabacion
        console.log('DATA PARATRABAJO CON API: ', data)
        if(proceder === true){
            let config_request = {
                method: 'POST',
                url: '/devolucionesporaprobar',
                data
            }
            global_axios(config_request)
            .then((response)=> {          
                alert(response.data.msg);
                this.cargarDevoluciones(this.state.tipoDevolucion);
            })
            .catch((error)=>{                           
                alert(error.response?error.response.data.msg:error.message);
            })
        }else{
            alert(errors)
        }
    }

    render(){
        return(
            <ContenedorForm porc_ancho={95}>
            <HeaderForm>
                <TituloForm>Aprobación de Devoluciones</TituloForm>
                <LabelCabecera>Ult. trans.: {this.state.ult_transaccion}</LabelCabecera>
                <LabelCabecera>N°. diario: {this.state.num_diario}</LabelCabecera>
            </HeaderForm>
                <CuerpoForm>
                    <ContainerEdit margen_abajo="5">
                        <Row>
                            <ContainerCol className="col-sm-2 ">
                                <LabelForm>Devoluciones:</LabelForm>
                                <br/>
                                <LabelForm className='radio-inline'>
                                    <input type="radio" name="tipoDevolucion" value="L" checked={this.state.tipoDevolucion==="L"} onChange={this.actualizarCampos} />
                                    Listas
                                </LabelForm>
                                <LabelForm className='radio-inline'>
                                    <input type="radio" name="tipoDevolucion" value="F" checked={this.state.tipoDevolucion==="F"} onChange={this.actualizarCampos} />
                                    Modificados
                                </LabelForm>
                            </ContainerCol>                          
                            <ContainerCol className='col-sm-2 col-md-offset-8'>
                                <LabelForm>Fecha:</LabelForm>
                                <PickerFecha fechaSeleccionada={this.state.fechaProceso} disabled={!(this.props.permiteCambioFProceso==='S')} 
                                func_onChange={(fechaEscogida)=>{this.setState({fechaProceso: fechaEscogida})}}/>
                            </ContainerCol>
                        </Row>
                    </ContainerEdit>
                    <Row>
                        <ContainerCol margen_arriba="4" className='col-sm-4'>
                            <LabelForm>Obser. Revisión fisica</LabelForm>
                            <TextArea mayusculas="true" name="obsComercial" value={this.state.obsComercial}></TextArea>
                        </ContainerCol>
                        <ContainerCol margen_arriba="4" className='col-sm-4'>
                            <LabelForm>Obser. Contraloria</LabelForm>
                            <TextArea mayusculas="true" name="obsContraloria" value={this.state.obsContraloria}></TextArea>
                        </ContainerCol>
                        <ContainerCol  margen_arriba="4" className='col-sm-4'>
                            <LabelForm>Obser. Gerencia</LabelForm>
                            <TextArea  mayusculas="true" name="obsGerencia" value={this.state.obsGerencia}></TextArea>
                        </ContainerCol>
                        
                        
                    </Row>
                    <Row>
                        <ContainerCol margen_arriba="4" className={this.state.tipoDevolucion==='L'?'col-sm-10':'col-sm-7'}>
                            <ContainerCol margen_arriba="4" className='col-sm-12'>
                                <LabelForm>Devoluciones por Aprobar</LabelForm>
                                <AgGridRender altura='105px' data={this.state.dataDevolucionesPorAprobar} columnas={this.state.coldefDevolucionesPorAprobar}
                                gridOptions={this.DevolucionesPorAprobarOptions} onGridReady={this.onGridDevolucionesPorAprobarReady}/>
                            </ContainerCol>
                        </ContainerCol>
                        <ContainerCol className={this.state.tipoDevolucion==='L'?'col-sm-2':'col-sm-5'}>
                            <Row margen_arriba="45">
                                <ContainerCol className='col-sm-2' isInvisible={this.state.tipoDevolucion==='L'?true:false}>
                                    <LabelForm>Motivo Aprobación:</LabelForm>
                                </ContainerCol>
                                <ContainerCol  className='col-sm-7' isInvisible={this.state.tipoDevolucion==='L'?true:false}>
                                    <TextArea mayusculas='true' name="motAprobacion" value={this.state.motAprobacion} onChange={this.actualizarCampos}></TextArea>
                                </ContainerCol>
                                <ContainerCol className='col-sm-2'>
                                    <button type='button' className='btn btn-default btn-sm' disabled={this.state.devolucion_sel===null?true:false} onClick={this.toggleModalHistorial}><i className='fa fa-list'></i> Historial</button>  
                                </ContainerCol>
                            </Row>
                            <Row>
                                {this.state.tipoDevolucion==='L'?<br/>:''}
                                <ContainerCol className='col-sm-2' isInvisible={this.state.tipoDevolucion==='L'?true:false}>
                                    <LabelForm>Motivo Rechazo:</LabelForm>
                                </ContainerCol>
                                <ContainerCol  className='col-sm-7' isInvisible={this.state.tipoDevolucion==='L'?true:false}>
                                    <TextArea mayusculas='true' name="motRechazo" value={this.state.motRechazo} onChange={this.actualizarCampos}></TextArea>
                                </ContainerCol>                               
                            </Row>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol margen_arriba="4" className='col-sm-10 col-sm-offset-2 col-sm-pull-2'>
                            <LabelForm>Detalle Devolución: {this.state.devolucion_sel}</LabelForm>
                            <AgGridRender altura='175px' data={this.state.dataDetDevoluciones} columnas={this.state.coldefDetDevoluciones}
                            gridOptions={this.DetDevolucionesOptions} onGridReady={this.onGridDetDevolucionesReady}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <div className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm' disabled={this.state.errorAjusteExistente===1||this.state.operacion==='M'?true:false} onClick={this.guardarAprobacionDevolucionElectronica}><i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                                <button type='button' className='btn btn-sm' onClick={this.limpiarPantalla}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                                {/* <button type='button' className='btn btn-danger btn-sm' disabled={this.state.operacion==='M'?false:true} onClick={this.anularAjusteGastoImp}><i className='fa fa-window-close  fa-lg'/> Anular</button>*/}
                            </div>
                        </div>
                    </Row>
                </CuerpoForm>
                {/*MODAL DETALLE FACTURA DEVOLUCION*/}
                <ModalResponsive open={this.state.isOpenModalFac} onClose={()=>{this.setState({isOpenModalFac: false})}}>
                    <HeaderForm>
                        <TituloForm>Anexo</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModal> 
                            <Row>
                                <ContainerCol className='col-md-12'>
                                    <LabelForm>Factura original por artículo: {this.state.labelArt}</LabelForm>
                                    <AgGridRender altura='100px' data={this.state.gridDetFactura} columnas={this.state.colDefDetFactura} gridOptions={this.gridOptionsDetFactura} onGridReady={this.onGridDetFacturaReady}/>   
                                </ContainerCol>                                
                            </Row>
                        </ContenedorModal>
                    </CuerpoForm>
                </ModalResponsive> 
                {/*MODAL HISTORIAL DEVOLUCIONES */}
                <ModalResponsive open={this.state.isOpenModalHistorial} onClose={()=>{this.setState({isOpenModalHistorial: false})}}>
                    <HeaderForm>
                        <TituloForm>Historial {this.state.modalHistorial}</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <ContenedorModalHistorial>
                            <Row>
                                <ContainerCol className='col-md-6 col-md-offset-6 col-md-pull-6'>
                                    <LabelForm>Devolución: {this.state.devolucion_sel}</LabelForm>
                                    <LabelForm>{this.state.cabecera}</LabelForm>
                                </ContainerCol>
                            </Row> 
                            <Row>
                                <ContainerCol className='col-md-12'>                                    
                                    <AgGridRender altura='305px' data={this.state.gridHistorial} columnas={this.state.colDefHistorial} gridOptions={this.gridOptionsHistorial} onGridReady={this.onGridHistorialReady}/>   
                                </ContainerCol>                                
                            </Row>
                        </ContenedorModalHistorial>
                    </CuerpoForm>
                </ModalResponsive> 
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
return {puntoFacturacionSel: state.ventas.ptoFacturacionSel, 
        fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
        permiso: state.sesion.valoresSesionForm.Permiso,
        usuario: state.sesion.valoresSesionForm.Usuario,
        IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
        permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
        diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
        departamento : state.sesion.valoresSesionForm.Departamento}
});
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cambiar_VisualizacionLoading}, dispatch)
});
export default connect (mapStateToProps, mapDispatchToProps)(FormVen08);